export const SpecialRECStates = ['New Jersey', 'Massachusetts', 'Illinois'];